import { createSlice } from '@reduxjs/toolkit';

const errorSlice = createSlice({
    name: 'error',
    initialState: {
        message: null, // Almacena el mensaje del error
        status: null, // Almacena el código de estado HTTP
        redirectTo: null,   // Ruta de redirección
    },
    reducers: {
        setError: (state, action) => {
            state.message = action.payload.message;
            state.status = action.payload.status;
            state.redirectTo = action.payload.redirectTo || null;
        },
        clearError: (state) => {
            state.message = null;
            state.status = null;
            state.redirectTo = null;
        },
    },
});

export const { setError, clearError } = errorSlice.actions;

export default errorSlice.reducer;
